import { facilitiesInitialized } from '@/services/facilities';
import { userConfirmedLoggedInPromise } from '../cross-app-frontend/firebase';
import { errorModalShowStandard } from '@/services/errors';

export const initialLoadingPromise = userConfirmedLoggedInPromise
  .then(() => facilitiesInitialized)
  .catch((e) => {
    console.error('Error thrown during app login checks:', e);
    errorModalShowStandard(e);
  });
